import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockArrowRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.25 9.002V6.625c0-.623-.502-1.125-1.125-1.125S4 6.002 4 6.625v5.25C4 12.498 4.502 13 5.125 13h5.25c.623 0 1.125-.502 1.125-1.125s-.502-1.125-1.125-1.125H7.783A9.74 9.74 0 0 1 16 6.25 9.75 9.75 0 0 1 25.75 16 9.75 9.75 0 0 1 16 25.75a9.7 9.7 0 0 1-5.377-1.617 1.126 1.126 0 0 0-1.247 1.875A11.97 11.97 0 0 0 16 28c6.628 0 12-5.372 12-12S22.628 4 16 4a11.98 11.98 0 0 0-9.75 5.002M16 10c-.623 0-1.125.502-1.125 1.125V16c0 .3.117.586.328.797l3.375 3.375a1.125 1.125 0 0 0 1.59-1.59l-3.048-3.046v-4.411c0-.623-.501-1.125-1.125-1.125z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M4 4h24v24H4z"
		})
	}) })]
});
export default SvgClockArrowRegularIcon;
